(function () {
  if (window.__bsMotionInit) return;
  window.__bsMotionInit = true;
  var d = document, de = d.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  de.classList.add('bs-motion');
  if (reduced) de.classList.add('bs-reduced');

  function onReady(fn) {
    if (d.readyState !== 'loading') fn();
    else d.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var reveals = Array.prototype.slice.call(d.querySelectorAll('.bs-reveal'));
    var pEls = Array.prototype.slice.call(d.querySelectorAll('[data-bs-parallax]'));
    var mechs = Array.prototype.slice.call(d.querySelectorAll('.bs-mech'));
    var satc = d.querySelector('.bs-satc');
    var satcTarget = null;

    d.querySelectorAll('[data-bs-stagger]').forEach(function (g) {
      g.querySelectorAll('.bs-reveal').forEach(function (k, i) {
        k.style.setProperty('--bs-d', (i * 0.09) + 's');
      });
    });

    if (reduced) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      mechs.forEach(function (m) {
        m.querySelectorAll('.bs-mech__step').forEach(function (s) { s.classList.add('is-active'); });
      });
      reveals = [];
      pEls = [];
      mechs = [];
    }

    if (satc) {
      d.body.classList.add('bs-has-satc');
      satcTarget = d.querySelector('.product__info-container form[action*="/cart/add"]') || d.querySelector('product-form form[action*="/cart/add"]') || d.querySelector('.bs-hero');
      if (!satcTarget) satc.classList.add('is-visible');
    }

    if (!reveals.length && !pEls.length && !mechs.length && !satc) return;

    var lastY = -1, lastH = -1, settleFrames = 0;

    function frame() {
      var y = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight;
      if (y === lastY && vh === lastH && settleFrames > 6) {
        requestAnimationFrame(frame);
        return;
      }
      if (y === lastY && vh === lastH) { settleFrames++; } else { settleFrames = 0; }
      lastY = y; lastH = vh;

      for (var i = reveals.length - 1; i >= 0; i--) {
        var r = reveals[i].getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) {
          reveals[i].classList.add('is-in');
          reveals.splice(i, 1);
        }
      }

      mechs.forEach(function (mech) {
        var track = mech.querySelector('.bs-mech__track');
        var steps = mech.querySelectorAll('.bs-mech__step');
        var bars = mech.querySelectorAll('.bs-mech__bar');
        if (!track || !steps.length) return;
        var tr = track.getBoundingClientRect();
        var span = tr.height - vh;
        if (span <= 0) return;
        var progress = Math.min(Math.max(-tr.top / span, 0), 1);
        var idx = Math.min(Math.floor(progress * steps.length), steps.length - 1);
        for (var j = 0; j < steps.length; j++) {
          steps[j].classList.toggle('is-active', j === idx);
          if (bars[j]) bars[j].classList.toggle('is-done', j <= idx);
        }
      });

      pEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.dataset.bsParallax) || 0.06;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });

      if (satc && satcTarget) {
        var tr2 = satcTarget.getBoundingClientRect();
        satc.classList.toggle('is-visible', tr2.bottom < 0);
      }

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  });
})();
